/*
  The game page's set search while pages are still arriving (R14 of
  docs/specs/pop-report-followups.md): the sets already loaded, then any part-name match
  the server found that has not loaded yet. Each set once, by id, and the loaded copy wins.

  Deduped with filter, as GameView dedupes: that file imports the set TYPE as `Set`,
  which shadows the built-in there.
*/

export const mergeSetMatches = <T extends { id: number }>(
  loaded: readonly T[],
  server: readonly T[]
): T[] => {
  const loadedIds = loaded.map((set) => set.id);
  const fresh = server.filter(
    (set, index) =>
      !loadedIds.includes(set.id) && server.findIndex((other) => other.id === set.id) === index
  );
  return [...loaded, ...fresh];
};
